import { AppShell, Content } from '../../components/ui/AppShell';
import { DesktopColumns } from '../../components/ui/DesktopColumns';
import { toast } from '../../lib/toast';
import { AccountSection } from './AccountSection';
import { GameplaySection, NotificationsSection } from './GameplayNotificationsSections';
import { AccountHero, SettingsNav } from './SettingsHeader';
import { BlockedSheet, ConfirmDelete, SelectSheet } from './SettingsSheets';
import { GoProBanner, PrivacySection, SettingsFooter, SupportSection } from './PrivacySupportSections';
import { useSettingsScreen } from './useSettingsScreen';

export default function SettingsScreen() {
  const s = useSettingsScreen();

  return (
    <AppShell>
      <Content>
        <SettingsNav />

        <DesktopColumns
          railFirst
          asidePosition="left"
          asideWidth="360px"
          aside={
            <AccountHero
              name={s.name}
              username={s.username}
              tone={s.tone}
              photoURL={s.profile?.photoURL}
              headlineTier={s.headlineTier}
            />
          }
          main={
            <>
        <AccountSection
          user={s.user}
          username={s.username}
          isPasswordUser={s.isPasswordUser}
          resetState={s.resetState}
          onResetPassword={s.onResetPassword}
        />

        <GameplaySection
          favourite={s.favourite}
          defaultLeague={s.defaultLeague}
          joinedLeagues={s.joinedLeagues}
          pickReminders={s.notifs.pickReminders}
          onPickTeam={() => s.setPicker('team')}
          onPickLeague={() => s.setPicker('league')}
          onPickRemindersChange={(v) => s.setNotif('pickReminders', v)}
        />

        <NotificationsSection
          pushSupported={s.pushSupported}
          pushPerm={s.pushPerm}
          notifs={s.notifs}
          onEnablePush={s.onEnablePush}
          onNotifChange={s.setNotif}
        />

        <PrivacySection
          blockedCount={s.blocked?.length ?? 0}
          onShowBlocked={() => s.setShowBlocked(true)}
        />

        <GoProBanner />
        <SupportSection />

        <SettingsFooter
          onSignOut={() => s.signOut()}
          onDeleteAccount={() => s.setConfirmDelete(true)}
        />
            </>
          }
        />
      </Content>

      <SelectSheet
        open={s.picker === 'team'}
        title="Favourite team"
        options={s.teamOptions.map((t) => ({ id: t.code, label: t.name, code: t.code }))}
        selectedId={s.favourite?.code}
        onClose={() => s.setPicker(null)}
        onSelect={(opt) => {
          s.updateDoc.mutate({ favouriteTeam: { name: opt.label, code: opt.id } });
          s.setPicker(null);
        }}
      />

      <SelectSheet
        open={s.picker === 'league'}
        title="Default league"
        options={s.joinedLeagues.map((l) => ({
          id: l.leagueId,
          label: l.name,
          code: l.code,
          country: l.country
        }))}
        variant="league"
        selectedId={s.profile?.defaultLeagueId}
        onClose={() => s.setPicker(null)}
        onSelect={(opt) => {
          s.updateDoc.mutate({ defaultLeagueId: opt.id });
          s.setPicker(null);
        }}
      />

      <ConfirmDelete
        open={s.confirmDelete}
        busy={s.deleteAccount.isPending}
        onCancel={() => s.setConfirmDelete(false)}
        onConfirm={s.onDelete}
      />

      <BlockedSheet
        open={s.showBlocked}
        blocked={s.blocked ?? []}
        busy={s.unblockUser.isPending}
        onClose={() => s.setShowBlocked(false)}
        onUnblock={(id) =>
          s.unblockUser.mutate(id, {
            onSuccess: () => toast('Player unblocked.'),
            onError: () => toast('Could not unblock. Try again.')
          })
        }
      />
    </AppShell>
  );
}
